/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/accessible-emoji */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */

import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import styled from "styled-components";
import { datadogRum } from "@datadog/browser-rum";

import * as API from "../../../../api/billing";
import Modal from "../../../reusable/reactModal";
import {
  StyledButton,
  StyledButtonContainer,
  StyledTextarea,
} from "../lib/styles";
import { theme } from "../../../theme/theme";

const StyledContainer = styled.div`
  background-color: ${theme.color.yellowLightest};
  border-radius: ${theme.radius.s};
  padding: 16px 24px;
  border: 1px solid ${theme.color.gray};
`;

const StyledLinkButton = styled.button`
  cursor: pointer;
  color: ${theme.color.blueLink};
  background-color: transparent;
  border: none;
  text-decoration: underline;
  padding-right: 0px;

  &:hover {
    color: ${theme.color.purple};
  }
`;

const FeedbackCard = (): React.ReactElement => {
  const [modal, setModal] = React.useState<string>("");
  const [feedback, setFeedback] = React.useState<string>("");

  const closeModal = (): void => {
    return setModal("");
  };

  const handleTextareaChange = (event): void => {
    setFeedback(event.target.value);
  };

  const submitFeedback = async (): Promise<void> => {
    try {
      await API.submitFeedback({
        beta_feedback: {
          feature: "billing_activity",
          notes: feedback,
          url: window.location.href,
        },
      });
    } catch (error) {
      datadogRum.addError(error);
    } finally {
      closeModal();
    }
  };

  return (
    <StyledContainer data-testid="feedback-container">
      {i18n.translate("admin_pages.activity.billing_activity_feedback")}{" "}
      <StyledLinkButton
        data-testid="feedback-button"
        onClick={(): void => {
          return setModal("feedback");
        }}
        type="button"
      >
        {i18n.translate(
          "admin_pages.activity.billing_activity_feedback_button"
        )}
      </StyledLinkButton>
      !
      <Modal
        ariaLabel="feedback modal"
        close={closeModal}
        showDialog={modal === "feedback"}
        testId="feedback-modal"
        title={`${i18n.translate("admin_pages.activity.feedback_modal.title")}`}
      >
        <>
          <StyledTextarea
            data-testid="feedback-textarea"
            onChange={handleTextareaChange}
            value={feedback}
          />
          <StyledButtonContainer>
            <StyledButton
              onClick={closeModal}
              size="small"
              testId="cancel-feedback-button"
              variant="secondary"
            >
              {`${i18n.translate(
                "admin_pages.activity.feedback_modal.cancel"
              )}`}
            </StyledButton>
            <StyledButton
              disabled={!feedback}
              onClick={submitFeedback}
              size="small"
              testId="submit-feedback-button"
              variant="primary"
            >
              {`${i18n.translate(
                "admin_pages.activity.feedback_modal.submit_feedback"
              )}`}
            </StyledButton>
          </StyledButtonContainer>
        </>
      </Modal>
    </StyledContainer>
  );
};

export default FeedbackCard;
